import { RouteRecordRaw } from 'vue-router'
import { authGuard } from '../guards/authGuard.js'
import { generateServiceRoutes } from '@/shared/config/services'
import DefaultLayout from '@/shared/layouts/DefaultLayout.vue'
import { invoiceRoutes } from './invoices.js'
import { paymentRoutes } from './payments.js'
import { inventoryRoutes } from './inventory.js'
import { locationRoutes } from './locations.ts'

const landingRoutes: RouteRecordRaw = {
  path: '/',
  component: DefaultLayout,
  children: [
    {
      path: '',
      name: 'landing',
      component: () => import('@/features/landing/pages/LandingPage.vue'),
      meta: {
        title: 'Plaza Muffler & Hitch | Expert Auto Exhaust & Trailer Hitch Installation',
        subtitle: 'Your trusted local muffler shop and trailer hitch installation experts since 1978',
        description: 'Local expert muffler repair, custom exhaust systems, and professional trailer hitch installation. Certified technicians, same-day service available.'
      }
    },
    {
      path: 'about',
      name: 'about',
      component: () => import('@/features/landing/pages/AboutPage.vue'),
      meta: {
        title: 'About Plaza Muffler & Hitch | Local Exhaust & Towing Experts',
        subtitle: 'Over 45 years of expert automotive exhaust and trailer hitch services',
        description: 'Family-owned muffler shop specializing in custom exhaust systems, catalytic converters, and trailer hitch installation. Serving Orange County since 1978.'
      }
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('@/features/landing/pages/OurServices.vue'),
      meta: {
        title: 'Auto Exhaust & Trailer Hitch Services | Plaza Muffler & Hitch',
        subtitle: 'Complete exhaust repair, custom fabrication, and trailer hitch solutions',
        description: 'Professional muffler repair, custom exhaust systems, catalytic converter replacement, and trailer hitch installation. Certified technicians, trusted intallations.'
      }
    },
    {
      path: '/locations',
      name: 'locations',
      component: () => import('@/features/locations/LocationsPage.vue'),
      meta: {
        title: 'Plaza Muffler & Hitch Locations | Orange County Muffler Shop Services',
        subtitle: 'Three convenient locations serving Orange County',
        description: 'Visit our muffler shops in Orange, Westminster, and Santa Ana. Expert exhaust repair and trailer hitch installation at all locations. Same-day service available.'
      }
    },
    ...locationRoutes,
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/features/profile/Profile.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/callback',
      component: () => import('@/features/auth/Callback.vue'),
    },
    ...generateServiceRoutes(),
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
}

export const routes: RouteRecordRaw[] = [landingRoutes, invoiceRoutes, paymentRoutes, inventoryRoutes]